import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { FiltersBar, FilterSelector, FilterTextField } from '../../../Utils/Filters/Filter'
import { fetchMassNotifications } from '../../../../actions/massNotification/massNotificationList'
import MassNotification from '../../../../models/MassNotification'
import { MassNotificationListState } from '../../../../reducers/massNotification/massNotificationList'
import { AppState } from '../../../../reducers'
import MassNotifications from '..'
import { Fab, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { personTypeToDescription, visiblePersonTypes } from '../../../Client/Profile'
import { SessionState } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { t } from 'i18next'

interface Props {
  massNotificationList: MassNotificationListState
  session: SessionState
}

export const translateStatusMassNotificationDescription = (value: string): string => {
  const statusMap: { [key: string]: string } = {
    PENDING: 'PENDING',
    SENT: 'SENT',
    CANCELLED: 'CANCELLED'
  }
  return t(`massNotification:${statusMap[value]}` || value)
}

export const MassNotificationList: React.FC<Props> = ({ massNotificationList, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['massNotification', 'person'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchMassNotifications(history.location.search))
  }, [dispatch, history.location.search])

  const onClickEdit = (massNotification: MassNotification) => {
    history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/massNotifications/update/${massNotification.id}`)
  }

  const translatePersonTypeDescription = (value: string): string => t(personTypeToDescription(value), { ns: 'person' })
  return (
    <div>
      <FiltersBar>
        <FilterTextField name="title" label={t("title")}  style={{ minWidth: '300px'}} />
        <FilterSelector name="personType" label={t("personType")} style={{ minWidth: '300px'}} menuItems={visiblePersonTypes} textAdapter={translatePersonTypeDescription}/>
        <FilterSelector name="status" label={t("status")} menuItems={['PENDING','CANCELLED', 'SENT']} textAdapter={translateStatusMassNotificationDescription}/>
      </FiltersBar>
      <MassNotifications
        rows={(massNotificationList.massNotifications || []).map(s => ({ data: s }))}
        loading={massNotificationList.isFetching}
        pagination={massNotificationList.pagination}
        onClickInfo={onClickEdit}
      />
      <Tooltip title={t("create")}>
        <Fab color="primary" variant="extended"
          sx={{ position: 'fixed', bottom: theme.spacing(4), right: theme.spacing(3) }}
          onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/massNotifications/create`)}>
          <Add />
        </Fab>
      </Tooltip>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  massNotificationList: state.massNotificationList,
  session: state.session
})

export default connect(mapStateToProps, null)(MassNotificationList)